import { BrowserRouter } from 'react-router-dom';
import { AllRoutes } from './index';
import Toast from '../components/Toast';
import ActiveJobsPopup from '../components/JobsPopup';

const Routes = () => {

    return (
        <BrowserRouter>
            <Toast />
            <ActiveJobsPopup />
            <AllRoutes />
        </BrowserRouter>
    );
};

export default Routes;
